import styled from "styled-components/native";
import ImgProgressBar from "./ImgProgressBar";
import { light_black } from "../../StyleHelpers";

const StyledContainer = styled.View`
	width: 100%;
	height: 100vh;
	z-index: -1;
	background-color: ${light_black};
`;

const Title = styled.View`
	width: 440px;
	height: 48px;
	border-radius: 16px;
	left: 4.8%;
	top: 24px;
	overflow: hidden;
`;

const BodyContainer = styled.View`
	display: flex;
	width: 100%;
	height: 90vh;
	padding: 24px 24px;
	gap: 16px;
	flex-direction: row;
`;

const LineBar = styled.View`
	position: absolute;
	left: 55px;
	width: 4px;
	height: 99%;
`;
const Circle = styled.View`
	width: 16px;
	height: 16px;
	background: #363636;
	border-radius: 12px;
`;

const StepTitle = styled.View`
	border-radius: 16px;
	width: 48px;
	height: 8px;
`;

const StepperContainer = styled.View`
	width: 138px;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	margin-top: 30px;
	padding-left: 50px;
`;

const ContentContainer = styled.View`
	margin-top: 30px;
	gap: 20px;
	flex: 1 0 0;
`;

const ButtonContainer = styled.View`
	margin-top: 30px;
	width: 500px;
	gap: 20px;
	padding-left: 30px;
`;
const StepperMain = styled.View`
	display: flex;
	flex-direction: row;
	gap: 20px;
`;

const StepperTitleMain = styled.View`
	display: flex;
	flex-direction: column;
	gap: 3px;
`;

const ButtonStyled = styled.View<any>`
	display: flex;
	width: 100%;
	height: ${(props) => props.height}px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 10px;
	align-self: stretch;
	border-radius: ${(props) => (props.height !== 32 ? "12px" : 0)};
`;
const HaftContent = styled.View`
	display: flex;
	flex-direction: row;
	width: 49%;
	gap: 20px;
`;

const buttonSizePrimary = 56;
const buttonSizeSecondary = 32;

const PaymentNarrowLoader = () => {
	const renderStepperContent = () => {
		return (
			//@ts-ignore
			<StepperMain>
				{/* @ts-ignore */}
				<Circle>
					<ImgProgressBar />
				</Circle>
				{/* @ts-ignore */}
				<StepperTitleMain>
					{/* @ts-ignore */}
					<StepTitle>
						<ImgProgressBar />
					</StepTitle>
					{/* @ts-ignore */}
					<StepTitle>
						<ImgProgressBar />
					</StepTitle>
				</StepperTitleMain>
			</StepperMain>
		);
	};

	const renderButtonContent = (height?: any) => {
		// @ts-ignore
		return (
			<ButtonStyled height={height}>
				<ImgProgressBar isNoBorder={height === buttonSizeSecondary} />
			</ButtonStyled>
		);
	};

	return (
		// @ts-ignore
		<StyledContainer>
			{/* @ts-ignore */}
			<Title>
				<ImgProgressBar />
			</Title>
			{/* @ts-ignore */}
			<BodyContainer>
				{/* @ts-ignore */}
				<StepperContainer>
					{/* @ts-ignore */}
					<LineBar>
						<ImgProgressBar />
					</LineBar>
					{renderStepperContent()}
					{renderStepperContent()}
					{renderStepperContent()}
				</StepperContainer>
				{/* @ts-ignore */}
				<ButtonContainer>
					{renderButtonContent(buttonSizePrimary)}
					{renderButtonContent(buttonSizePrimary)}
					{renderButtonContent(buttonSizeSecondary)}
				</ButtonContainer>
				{/* @ts-ignore */}
				<ContentContainer>
					{/* @ts-ignore */}
					<HaftContent>
						{renderButtonContent(buttonSizePrimary)}
						{renderButtonContent(buttonSizePrimary)}
					</HaftContent>
					{renderButtonContent(buttonSizePrimary)}
					{/* @ts-ignore */}
					<HaftContent>
						{renderButtonContent(buttonSizePrimary)}
						{renderButtonContent(buttonSizePrimary)}
					</HaftContent>
					{renderButtonContent(buttonSizeSecondary)}
				</ContentContainer>
			</BodyContainer>
		</StyledContainer>
	);
};

export default PaymentNarrowLoader;
